import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { QcChecklistCreatePage } from '@/features/workflows';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/qc-checklists/new')({
  staticData: { crumb: 'workflows:qc.new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.write');
  },
  component: QcChecklistCreatePage,
});
